<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="店铺名称" prop="shopName">
                <a-input v-model="queryParam.shopName" placeholder="请输入店铺名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="统一社会信用代码" prop="businessLicenseUSCI">
                <a-input v-model="queryParam.businessLicenseUSCI" placeholder="请输入统一社会信用代码" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="省" prop="areap">
                <a-input v-model="queryParam.areap" placeholder="请输入省" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="市" prop="areac">
                <a-input v-model="queryParam.areac" placeholder="请输入市" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="区(县)" prop="areax">
                <a-input v-model="queryParam.areax" placeholder="请输入区(县)" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="城市线级" prop="tierCities">
                <a-select style="width: 100%" v-model="queryParam.tierCities" placeholder="请选择城市线级" allow-clear>
                  <a-select-option :value="1">一线</a-select-option>
                  <a-select-option :value="1.5">新一线</a-select-option>
                  <a-select-option :value="2">二线</a-select-option>
                  <a-select-option :value="3">三线</a-select-option>
                  <a-select-option :value="4">四线</a-select-option>
                  <a-select-option :value="5">五线</a-select-option>
                  <a-select-option :value="-1">暂无</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="是否认证" prop="isAuth">
                <a-select style="width: 100%" v-model="queryParam.isAuth" placeholder="请选择是否认证" allow-clear>
                  <a-select-option :value="0">否</a-select-option>
                  <a-select-option :value="1">是</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="标签库id,多个之间用逗号分隔" prop="label">
                  <a-input v-model="queryParam.label" placeholder="请输入标签库id,多个之间用逗号分隔" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="openShopTierCitiesModal" v-hasPermi="['shop:shop/audit:remove']">
          <a-icon type="edit" />修改城市线级
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['shop:shop/audit:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['shop:shop/audit:export']">
          <a-icon type="download" />导出
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <div class="card">
        <a-row type="flex" justify="center">
          <a-col
            :xs="8"
            :sm="8"
            :md="8"
            :lg="8"
            :xl="8"
            class="border-right border-bottom">
            <a-card :bordered="false">
              <a-card-meta title="店铺数量">
                <template slot="description">
                  <span style="font-size: 18px;color: #ec5551;" class="card-money">{{ data.shopNum }}</span>个
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
          <!--          <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <a-card :bordered="false" class="border-right border-bottom">
              <a-card-meta title="店铺销售总额">
                <template slot="description">
                <span style="font-size: 18px;color: #ec5551;"
                      class="card-money">{{data.shopSumAmount}}</span>元
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
        </a-row>
        <a-row type="flex" justify="center">
          <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <a-card :bordered="false" class="border-right">
              <a-card-meta title="店铺已结算金额">
                <template slot="description">
                  <span style="font-size: 18px;color: #ec5551;" class="card-money">{{data.shopSetAmount}}</span>元
                </template>
              </a-card-meta>
            </a-card>
          </a-col>
          <a-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <a-card :bordered="false" class="border-right">
              <a-card-meta title="店铺未结算金额">
                <template slot="description">
                  <span style="font-size: 18px;color: #ec5551;" class="card-money">{{data.shopUnSetAmount}}</span>元
                </template>
              </a-card-meta>
            </a-card>
          </a-col>-->
        </a-row>

      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :payMarginOptions="dict.type['shop_pay_margin']"
        @ok="getList"
      />
      <BatchBindScriptModal
        ref="BatchBindScriptModal"
        :bindScriptIds="batchScriptId"
        :bindScriptNames="batchScriptName"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >

        <span slot="operation" slot-scope="text, record">
          <!--           <a-divider type="vertical" v-hasPermi="['shop:shop:ban']" />-->
          <!--          <a @click="handleBan(record)" v-hasPermi="['shop:shop:ban']">-->
          <!--            <a-icon type="edit" />封禁-->
          <!--          </a>-->
          <!--          <a-divider type="vertical" v-hasPermi="['shop:shop:unseal']" />-->
          <!--          <a @click="handleUnseal(record)" v-hasPermi="['shop:shop:unseal']">-->
          <!--            <a-icon type="edit" />解封-->
          <!--          </a>-->
          <!--          <a-divider type="vertical" v-hasPermi="['shop:shop:margin']" />-->
          <a @click="margin(record)" v-hasPermi="['shop:shop:margin']">
            <a-icon type="edit" />缴纳保证金
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:edit']"/>
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:shop:edit']">
            <a-icon type="edit"/>详情（谨慎修改）
          </a>
          <a-divider type="vertical" v-hasPermi="['shop:shop:edit']" v-if="record.status === 2"/>
          <a @click="$refs.BatchBindScriptModal.open(record)" v-hasPermi="['shop:shop:edit']" v-if="record.status === 2">
            <a-icon type="edit"/>批量收录剧本
          </a>
        </span>
        <template slot="logo" slot-scope="text, record">
          <img v-if="record.logo" :src="record.logo" style="width:60px;height:62px;" @preview="handlePreview"/>
        </template>
        <template slot="isPay" slot-scope="text, record">
          <span>{{ record.isPay ? '已缴纳' : '未缴纳' }}</span>
          <!--          <dict-tag :options="dict.type['shop_pay_margin']" :value="record.isPay" />-->
        </template>
        <template slot="isAuth" slot-scope="text, record">
          <span>{{ record.isAuth ? '是' : '否' }}</span>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="blue">申请中</a-tag>
          <a-tag v-if="record.status === 2" color="green">正常</a-tag>
          <a-tag v-if="record.status === 3" color="red">封禁</a-tag>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :page-size-options="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
      <a-modal
        v-model="editShopTierCitiesVisible"
        title="修改城市线级"
        :closable="true"
      >
        <a-form-model ref="editShopTierCitiesForm" :model="editShopTierCitiesForm" :rules="editShopTierCitiesRules">
          <a-form-model-item label="城市线级" prop="tierCities" >
            <a-select style="width: 100%" v-model="editShopTierCitiesForm.tierCities" placeholder="请选择城市线级" allow-clear>
              <a-select-option :value="1">一线</a-select-option>
              <a-select-option :value="1.5">新一线</a-select-option>
              <a-select-option :value="2">二线</a-select-option>
              <a-select-option :value="3">三线</a-select-option>
              <a-select-option :value="4">四线</a-select-option>
              <a-select-option :value="5">五线</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
        <template slot="footer">
          <a-button type="primary" :loading="editShopTierCitiesLoading" @click="editShopTierCitiesSubmit()">
            修改
          </a-button>
          <a-button @click="editShopTierCitiesVisible = false">取消</a-button>
        </template>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  getShopList,
  delShop,
  banShop,
  unsealShop,
  getShopCountList,
  marginShop,
  updateShopTierCities
} from '@/api/shop/shop'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'
import CreateForm from './modules/CreateForm'
import BatchBindScriptModal from './modules/BatchBindScriptModal'
export default {
  name: 'ShopAudit',
  components: {
    CreateForm,
    BatchBindScriptModal
  },
  mixins: [tableMixin],
  dicts: ['shop_pay_margin'],
  data () {
    return {
      pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
      editShopTierCitiesVisible: false,
      editShopTierCitiesLoading: false,
      editShopTierCitiesForm: {
        tierCities: undefined,
        ids: undefined
      },
      editShopTierCitiesRules: {
        tierCities: [
          { required: true, message: '请选择城市线级', trigger: ['blur', 'change'] }
        ]
      },
      list: [],
      shopNum: null,
      shopSumAmount: '0',
      shopSetAmount: '0',
      shopUnSetAmount: '0',
      data: [],
      selectedRowKeys: [],
      selectedRows: [],
      selectedId: '',
      shopStatus: '3',
      reason: '',
      visible: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,

      batchScriptName: [],
      batchScriptId: [],
      // 查询参数
      queryParam: {
        legalPerson: null,
        mobile: null,
        shopName: null,
        servicePhone: null,
        label: null,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        tierCities: undefined,
        isAuth: undefined,
        businessLicenseUSCI: undefined,
        img: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '店铺名称',
          dataIndex: 'shopName',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '统一社会信用代码',
          dataIndex: 'businessLicenseUSCI',
          width: 180,
          align: 'center'
        },
        {
          title: '店铺logo',
          dataIndex: 'logo',
          scopedSlots: { customRender: 'logo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'areap',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'areac',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'areax',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '城市线级',
          dataIndex: 'tierCities',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 1) {
              return '一线'
            }
            if (text === 1.5) {
              return '新一线'
            }
            if (text === 2) {
              return '二线'
            }
            if (text === 3) {
              return '三线'
            }
            if (text === 4) {
              return '四线'
            }
            if (text === 5) {
              return '五线'
            }
            return text
          }
        },
        {
          title: '营业状态',
          dataIndex: 'businessStatus',
          // scopedSlots: { customRender: 'businessStatus' },
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return { 0: '正常营业' }[text]
          }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '认证',
          dataIndex: 'isAuth',
          scopedSlots: { customRender: 'isAuth' },
          ellipsis: true,
          width: 60,
          align: 'center'
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '保证金',
          dataIndex: 'isPay',
          scopedSlots: { customRender: 'isPay' },
          ellipsis: true,
          width: 70,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 250,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getShopCountList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    parseTime,
    handlePreview(file) {
      this.previewAvatar = file.url || file.preview
      this.previewVisible = true
    },
    /** 查询店铺审核信息列表 */
    getList () {
      this.loading = true
      getShopList(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 查询店统计信息列表 */
    getShopCountList () {
      this.loading = true
      getShopCountList(this.queryParam).then(response => {
        this.data = response.data
       // this.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        legalPerson: undefined,
        mobile: undefined,
        shopName: undefined,
        servicePhone: undefined,
        label: undefined,
        img: undefined,
        areap: undefined,
        areac: undefined,
        areax: undefined,
        isAuth: undefined,
        tierCities: undefined,
        businessLicenseUSCI: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          return delShop(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {}
      })
    },
    openShopTierCitiesModal() {
      this.editShopTierCitiesVisible = true
      this.editShopTierCitiesForm = {
        tierCities: undefined,
        ids: undefined
      }
    },
    editShopTierCitiesSubmit() {
      this.$refs.editShopTierCitiesForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.editShopTierCitiesLoading = true
        this.editShopTierCitiesForm.ids = this.ids
        updateShopTierCities(this.editShopTierCitiesForm).then(response => {
          this.$message.success(
            '修改成功',
            3
          )
          this.getList()
          this.editShopTierCitiesVisible = false
        }).finally(() => {
          this.editShopTierCitiesLoading = false
        })
      })
    },
    /** 封禁按钮操作 */
    handleBan (row) {
      var that = this
      const ids = row.id || this.ids
      const shopName = row.shopName
      this.$confirm({
        title: '确认封禁该店铺吗?',
        content: '当前选中店铺：' + shopName,
        onOk () {
          return banShop(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '封禁成功',
                3
              )
            })
        },
        onCancel () {}
      })
    },
    /** 解封按钮操作 */
    handleUnseal (row) {
      var that = this
      const ids = row.id || this.ids
      const shopName = row.shopName
      this.$confirm({
        title: '确认解封该店铺吗?',
        content: '当前选中店铺：' + shopName,
        onOk () {
          return unsealShop(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '解封成功',
                3
              )
            })
        },
        onCancel () {}
      })
    },
    /** 缴纳保证金 */
    margin (row) {
      var that = this
      const ids = row.id || this.ids
      const shopName = row.shopName
      this.$confirm({
        title: '确认修改保证金状态吗?',
        content: '当前选中店铺：' + shopName,
        onOk () {
          return marginShop(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '保证金缴纳成功',
                3
              )
            })
        },
        onCancel () {}
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('shop/shop/audit/export', {
            ...that.queryParam
          }, `shop/audit_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 审批 */
    handleAudit (row, ids) {
      this.formType = 2
      const id = row ? row.id : ids
      this.visible = true
      this.selectedId = id
    }
  }
}
</script>
<style lang="less" scoped>

.card {
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 20px;
}

.card > .card-money {
  font-size: 18px;
  color: #ec5551;
}

.card .border-right {
  border-right: 1px dashed #e8e8e8 !important;
}

.card .border-bottom {
  border-bottom: 1px dashed #e8e8e8 !important;
}

</style>
